




























































import { defineComponent } from '@vue/composition-api'
import CloseButton from '@/components/custom/CloseButton.vue'

export default defineComponent({
  name: 'AlertContainer',
  components: {
    CloseButton,
  },
  props: {
    alerts: Array,
  },
})
